import * as companies from './companies'

export default companies
